( function($, waTheme) {

    var Product = ( function($) {

        Product = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$form = that.$wrapper.find("form:first");
            that.$skus = that.$form.find(".s-skus-wrapper");
            that.$services = that.$form.find(".s-services-wrapper");
            that.$footer = that.$form.find(".s-product-footer");
            that.$button = that.$form.find("button[type=submit]");
            that.$button_checkout = that.$form.find(".js-checkout-link");
            that.$price = that.$form.find(".js-product-price");
            that.$comparePrice = that.$form.find(".js-compare-price");
            that.$base_price = that.$form.find(".js-product-base-price");
            that.$stock_base_ratio = that.$form.find(".js-stock-base-ratio");

            that.$zero_price = that.$form.find(".js-product-price-zero");
            that.$affiliate_points = that.$form.find(".js-product-affiliate");

            that.$stock_total_ratio = that.$form.find(".js-stock-total-ratio");
            that.$stock_total_quantity = that.$form.find(".js-stock-total-quantity");
            that.$total_price = that.$form.find(".js-product-total-price");

            //
            that.$savings = that.$form.find(".b-product-savings");

            //
            that.$page = that.$wrapper.parents("#js-product-page");

            // VARS
            that.is_dialog = ( options["is_dialog"] || false );
            that.dialog = (that.is_dialog ? that.$form.closest(".s-dialog-wrapper").data("dialog") : null);
            that.currency = options["currency"];
            that.currency_info = options["currency_info"];
            that.services = options["services"];
            that.features = options["features"];
            that.locales = options["locales"];
            // that.images = options["images"];
            that.product = options["product"];
            that.skus = that.product.skus;
            that.notification = window.waTheme.themesettings.settings["apps__shop_common_product_added_notification_type_buttons"]["value"];
            that.add_by_quantity = window.waTheme.themesettings.settings["product__common_add_by_quantity"]["value"];

            that.$quantity = that.$form.find(".js-quantity-field");
            that.quantity_controller = that.$quantity.data("controller");
            that.$quantity_section = that.quantity_controller.$wrapper;

            // Swiper
            that.thumbs = that.is_dialog ? "productThumbsSwiperDialog" : "productThumbsSwiper",
            that.main = that.is_dialog ? "productMainSwiperDialog" : "productMainSwiper";

            // Игнорировать ограничения складов
            that.ignore_stock_count = options["ignore_stock_count"];

            // Настройки дробных
            that.fractional_config = formatFractionalConfig(options["fractional_config"]);
            // Массив с единицами измерения
            that.units = options["units"];

            // DYNAMIC VARS
            that.sku_id = that.product.sku_id;
            that.sku = that.skus[that.sku_id];

            that.price = parseFloat( that.$price.data("price") );
            that.compare_price = parseFloat( that.$comparePrice.data("compare-price") );

            // INIT
            that.initProduct();

            // console.log( that );

            function formatFractionalConfig(config) {
                if (config) {
                    config.frac_enabled = (config.frac_enabled === "1");
                    config.stock_units_enabled = (config.stock_units_enabled === "1");
                    config.base_units_enabled = (config.base_units_enabled === "1");
                } else {
                    config = {};
                }

                return config;
            }
        };

        Product.prototype.initProduct = function() {
            var that = this;
            //
            that.bindEvents();
            //
            that.initSubmit();
            //
            that.initSwiper();
            //
            initFirstSku();
            //
            that.productsViewed();
            //
            that.initActiveTab();
            //
            function initFirstSku() {
                var $skuFeature = that.$form.find(".js-sku-feature:first"),
                    is_buttons_view_type = $skuFeature.length;

                // for sku buttons type
                if (is_buttons_view_type) {
                    var $selected = that.$form.find(".s-options-wrapper .active");
                    if ($selected.length) {
                        $selected.trigger("click");
                    } else {
                        initFirstButton( $skuFeature );
                    }

                // for sku radio type
                } else {
                    var $radio = getRadioInput();
                    if ($radio) {
                        $radio.trigger("change");
                    } else {
                        if (that.add_by_quantity === "1") {
                            that.productInCart();
                        }
                        // for single sku
                        that.updatePrice();
                    }
                }

                function getRadioInput() {
                    var $radios = that.$skus.find("input[type=radio]"),
                        result = false;

                    $.each($radios, function() {
                        var $radio = $(this),
                            is_enabled = !( $radio.attr("disabled") && ($radio.attr("disabled") === "disabled") ),
                            is_checked = ( $radio.attr("checked") && ($radio.attr("checked") === "checked") );

                        if ( is_enabled && (!result || is_checked) ) {
                            result = $radio;
                        }
                    });

                    return result;
                }

                function initFirstButton($skuFeature) {
                    var $wrapper = that.$form.find(".s-options-wrapper"),
                        is_select =  $wrapper.find("select").length;

                    if (is_select) {
                        $skuFeature.change();
                    } else {
                        var $groups = $wrapper.find(".inline-select"),
                            groups = getGroupsData( $groups ),
                            availableSku = getAvailableSku( groups );

                        if (availableSku) {
                            $.each(availableSku.$links, function() {
                                $(this).click();
                            });
                        }

                        function getGroupsData( $groups ) {
                            var result = [];

                            $.each($groups, function() {
                                var $group = $(this),
                                    $links = $group.find("a"),
                                    linkArray = [];

                                $.each($links, function() {
                                    var $link = $(this),
                                        id = $link.data("sku-id");

                                    linkArray.push({
                                        id: id,
                                        $link: $link
                                    });
                                });

                                result.push(linkArray);
                            });

                            return result;
                        }

                        function getAvailableSku( groups ) {
                            function selectionIsGood(prefix) {
                                var skuData = getSkuData( prefix ),
                                    sku = checkSku( skuData.id ),
                                    result = false;

                                if (sku) {
                                    result = {
                                        sku: sku,
                                        $links: skuData.$links
                                    }
                                }
                                return result;
                            }

                            function getFirstWorking(groups, prefix) {
                                if (!groups.length) {
                                    return selectionIsGood(prefix);
                                }

                                prefix = prefix || [];

                                var group = groups[0],
                                    other_groups = groups.slice(1);

                                for (var i = 0; i < group.length; i++) {
                                    var new_prefix = prefix.slice();
                                    new_prefix.push(group[i]);
                                    var result = getFirstWorking(other_groups, new_prefix);
                                    if (result) {
                                        return result;
                                    }
                                }

                                return null;
                            }

                            return getFirstWorking(groups);

                            function getSkuData( sku_array ) {
                                var id = [],
                                    $links = [];
                                $.each(sku_array, function(index, item) {
                                    id.push(item.id);
                                    $links.push(item.$link);
                                });

                                return {
                                    id: id.join(""),
                                    $links: $links
                                };
                            }
                        }

                        function checkSku( skus_id ) {
                            var result = false;

                            if (that.features.hasOwnProperty(skus_id)) {
                                var sku = that.features[skus_id];
                                if (sku.available) {
                                    result = sku;
                                }
                            }

                            return result;
                        }
                    }
                }
            }
        };

        Product.prototype.bindEvents = function() {
            var that = this;

            // add to cart block: services
            that.$services.find("input[type=checkbox]").on("click", function () {
                that.onServiceClick( $(this) );
                console.log("onServiceClick");
            });

            that.$services.find(".service-variants").on("change", function () {
                that.updatePrice();
            });

            that.$form.find('.inline-select a').on("click", function(event) {
                event.preventDefault();
                that.onSelectClick( $(this) );
            });

            // autobadge and other plugin tooltip fix
            that.$form.find('.inline-select a').on("mouseleave", function(event) {
                $("body").children(".tooltip").remove();
            });

            that.$skus.find("input[type=radio]").on("change", function () {
                var $input = $(this),
                    is_active = ($input.attr("checked") === "checked");

                if (is_active) {
                    that.onSkusClick( $(this) );
                }
            });

            that.$form.find(".js-sku-feature").change( function () {
                that.onSkusChange( $(this) );
            });


            // Добавление якоря при клике на таб
            $(".nav-tabs button.nav-link").on("click", function () {
                window.history.pushState(null, null, `#${$(this).attr("id")}`);
            });

            // Переключение табов при клике по ссылкам
            $(".js-bootstrap-tab").on("click", function () {
                var tab = $(this).attr("href");
                if (tab && tab !== "#") {
                    $(tab).click();
                }
            });

            // Дает возможность добавлять товары при помощи переключателя кол-ва
            if (that.add_by_quantity === "1") {
                that.$quantity_section.on("quantity.field.change", function (event, quantity, increase) {
                    event.preventDefault();
                    that.updateCart(quantity, increase);
                });
            }

            // Для обновления общей суммы
            that.$form.on("click", ".js-increase", function (event) {
                that.updatePrice();
            });

            that.$form.on("click", ".js-decrease", function (event) {
                that.updatePrice();
            });

            that.$form.on("change", function () {
                that.updatePrice();
            });

            // Добавление товара в корзину по кастомной кнопке
            $(".js-product-submit").on("click", function () {
                var $button = $(this);

                //
                that.$form.submit();
                $button.attr("disabled", true);
            });

            //
            $(document).on("theme_product_adding", function(event) {
                var $button = $(".js-product-submit");
                $button.attr("disabled", true);
            });

            //
            $(document).on("theme_product_add", function(event) {
                var $button = $(".js-product-submit"),
                    added_class = "is-added";

                $button.attr("disabled", false);
                $button.addClass(added_class);
                $button.removeClass("btn-theme").addClass("btn-outline-theme");
                $button.html(window.waTheme.locale["added_to_cart"]);
            });
        };

        Product.prototype.initActiveTab = function() {
            var that = this,
                hash = window.location.hash;

            console.log(hash);
            if (hash && $(hash).length) {
                $(hash).click();
            }
        }

        //
        // Если товар есть в корзине и включена настройка добавления товара при переключении кол-ва,
        // то меняем кол-во в пикере и меняем кнопку
        //

        Product.prototype.productInCart = function () {
            var that = this;

            $.get(`${window.waTheme.cart_url}?update_items=1`, function (html) {
                $("body").append(html);
            });

            let value = 0;
            for (const cartItem in window.waTheme.cart_items) {
                if (window.waTheme.cart_items[cartItem]["sku_id"] === that.sku["id"]) {
                    value = window.waTheme.cart_items[cartItem]["quantity"];
                }
            }

            that.quantity_controller.update({
                step: that.sku.order_count_step,
                min: that.sku.order_count_min,
                max: (!that.ignore_stock_count && that.sku.count > 0 ? that.sku.count : 0)
            });

            if (that.quantity_controller.value !== value) {
                that.quantity_controller.update({
                    value: value,
                });
            }

            that.productChangeButton(value);
        };

        Product.prototype.productChangeButton = function (quantity) {
            var that = this;

            if (quantity > 0) {
                that.$button.addClass("d-none btn-outline-theme").removeClass("btn-theme");
                that.$button_checkout.removeClass("d-none");
                that.$quantity_section.removeClass("d-none");
            } else {
                that.$button.removeClass("d-none btn-outline-theme").addClass("btn-theme");
                that.$button_checkout.addClass("d-none");
                that.$quantity_section.addClass("d-none");
            }
        };

        Product.prototype.updateCart = function(quantity, increase = false) {
            var that = this;

            let item = [];
            for (const cartItem in window.waTheme.cart_items) {
                if (window.waTheme.cart_items[cartItem]["sku_id"] === that.sku["id"]) {
                    item = window.waTheme.cart_items[cartItem];
                }
            }

            let data = {
                id: item["id"],
                html: 1,
                quantity: quantity,
            }

            // удаляем товар из корзины
            $.post(window.waTheme.cart_url + "delete/", data, function (response) {
                if (response.status === 'ok') {
                    // Если кол-во один и нажимаем на минус - не добавляем товары
                    if (quantity === 0 && increase === false) {
                        $.get(`${window.waTheme.cart_url}?update_items=1`, function (html) {
                            $("body").append(html);
                        });
                        waTheme.apps["shop"].cart.update(response["data"]);
                        that.productChangeButton(quantity);
                    } else {
                        // добавляем товар обратно
                        that.$form.submit();
                    }
                }
            });
        };

        //

        Product.prototype.initSubmit = function() {
            var that = this,
                $form = that.$form,
                is_locked = false,
                timer = 0;

            $form.on("submit", function(event) {
                event.preventDefault();
                console.log(event);
                onFormSubmit($form, event.originalEvent);
            });

            function onFormSubmit($form, originalE) {
                if (!is_locked) {
                    is_locked = true;

                    //
                    var href = $form.attr('action') + '?items=1&html=1',
                        dataArray = $form.serialize();

                    let data = $form.serializeArray()
                    let sku_id = null;
                    for (const dataKey in data) {
                        if (data[dataKey]["name"] === "sku_id") {
                            sku_id = data[dataKey]["value"];
                        }
                    }

                    // TOAST
                    if (that.is_dialog) {
                        var product_name = that.$wrapper.find(".s-product-name").html(),
                            product_image = that.$wrapper.find(".b-product-images__main .swiper-wrapper .swiper-slide:first-child").html();
                    } else {
                        var product_name = that.$page.data("product-name"),
                            product_image = that.$page.find(".b-product-images__main .swiper-wrapper .swiper-slide:first-child").html();
                    }

                    let toastHTML =
                        `<a class="b-products-toast d-flex" href="${window.waTheme.checkout_url}">
                            <div class="b-products-toast__image">
                               ${product_image}
                            </div>
                            <div class="ms-3">
                                <div class="fs-md fw-bold mb-1 text-dark">
                                    ${window.waTheme.locale.product_added_to_cart}
                                </div>
                                <div class="fs-sm mb-1">
                                    <span class="text-dark">${product_name}</span>
                                </div>
                                <div class="link-theme fs-sm">
                                    ${window.waTheme.locale.go_to_cart}
                                </div>
                            </div>
                        </a>`;

                    var $promise = $.post(href, dataArray, function (response) {

                        if (response.status === 'ok') {

                            if (that.is_dialog) {
                                var $dialog = $("#s-dialog-wrapper");
                                $dialog.trigger("addedToCart");
                            }

                            // Update Cart at Header
                            if (response["data"]) {
                                var count = response["data"]["count"],
                                    text = response["data"]["total"];

                                if (text && count >= 0) {
                                    waTheme.apps["shop"].cart.update(response["data"]);
                                }

                                if (originalE === undefined && that.add_by_quantity === "1") {
                                    that.notification = "hide";
                                }

                                if (that.notification === "toast") {
                                    const toast = new window.waTheme.init.site.Toast({
                                        html: toastHTML
                                    });
                                } else if (that.notification === "modal") {
                                    $.get(window.waTheme.cart_url + `?item_id=${response["data"]["item_id"]}&modal=1`, function (html) {
                                        const dialog = new window.waTheme.init.site.Dialog({
                                            html: html
                                        });

                                        var product_id = $(".b-product-added-modal .b-product-added-modal__item").data("product-id");
                                        new window.waTheme.init.shop.ProductsModal({
                                            $wrapper: $(".b-product-added-modal"),
                                        });
                                        new waTheme.init.shop.Quantity({
                                            $wrapper: $(".b-product-added-modal .s-quantity-section"),
                                            denominator: window.waTheme["products"][`${product_id}`].denominator,
                                            step: window.waTheme["products"][`${product_id}`].step,
                                            min: window.waTheme["products"][`${product_id}`].min,
                                            max: window.waTheme["products"][`${product_id}`].max,
                                            locales: window.waTheme["products"][`${product_id}`].locales,
                                            currency: window.waTheme["products"][`${product_id}`].currency,
                                        });
                                    });
                                }

                                // update cart items
                                // window.waTheme.cart_items[response["data"]["item_id"]] = {
                                //     "sku_id": sku_id,
                                //     "id": response["data"]["item_id"]
                                // }

                                $.get(`${window.waTheme.cart_url}?update_items=1`, function (html) {
                                    $("body").append(html);
                                });

                                // Дает возможность добавлять товары при помощи переключателя кол-ва
                                // let add_by_quantity = window.waTheme.themesettings.settings["product__common_add_by_quantity"]["value"];
                                // if (add_by_quantity === "1") {
                                //     $.get(`${window.waTheme.cart_url}?update_items=1`, function (html) {
                                //         $("body").append(html);
                                //     });
                                // }

                                // trigger custom event
                                $(document).trigger("theme_product_add");

                                if (that.add_by_quantity === "1") {
                                    that.productChangeButton(1);
                                }
                            }

                            if (response.data.error) {
                                alert(response.data.error);
                            }

                        } else if (response.status === 'fail') {
                            alert(response.errors);
                        }

                    }, "json").always( function() {
                        is_locked = false;
                    });

                    showButtonProgress();
                }

                function showButtonProgress() {
                    var $button = that.$form.find(".js-submit-button"),
                        time = 300;

                    var added_class = "is-added";

                    $button.attr("disabled", true);

                    $(document).trigger("theme_product_adding");

                    $promise.then( function(response) {

                        if (response.status === "ok") {

                            $button.addClass(added_class);
                            $button.removeClass("btn-theme").addClass("btn-outline-theme");
                            $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);

                            // show quantity
                            // that.$quantity_section.removeClass("d-none");

                            clearTimeout(timer);
                            timer = setTimeout( function() {
                                var is_exist = $.contains(document, $button[0]);
                                if (is_exist) {
                                    $button.attr("disabled", false);
                                }
                            }, time);
                        }
                    });
                }
            }
        };

        Product.prototype.initSwiper = function() {
            var that = this,
                wrapper_class = that.is_dialog ? ".s-product-dialog" : ".s-product-page";

            var thumbsOptions = {};
            if (document.querySelector(`${wrapper_class} .b-product-images__thumbs`) !== null) {
                window[that.thumbs] = new Swiper(`${wrapper_class} .b-product-images__thumbs > .swiper`, {
                    lazy: {
                        loadPrevNext: true,
                    },
                    spaceBetween: 5,
                    slidesPerView: 3,
                    direction: "vertical",
                    navigation: {
                        nextEl: "#product-thumbs-next",
                        prevEl: "#product-thumbs-prev"
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 6
                        }
                    },
                });
                thumbsOptions = {
                    thumbs: {
                        swiper: window[that.thumbs],
                    }
                }
            }

            window[that.main] = new Swiper(`${wrapper_class} .b-product-images__main > .swiper`, {
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 10,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                pagination: {
                    el: ".swiper-pagination",
                    dynamicBullets: true,
                },
                on: {
                    slideChange: function (swiper) {
                        let setting_state = window.waTheme.themesettings.settings["product__common_change_sku_on_image"]["value"];
                        if (setting_state === "1" && window.waTheme.license.is_premium === "1") {
                            let slide = swiper.slides[swiper.activeIndex];
                            if (slide !== undefined) {
                                let image_id = slide.getAttribute("data-image-id");
                                if (image_id !== null) {
                                    let $button = $(".s-skus-wrapper").find(`input[data-image-id="${image_id}"]`);
                                    if ($button.length) { $button.click(); }
                                }
                            }

                        }

                    },
                },
                ...thumbsOptions
            });

            if (that.is_dialog) {
                // Обновляем инстанс ленивой загрузки картинок
                waTheme.init.site.ImageLazyLoad.update();
            }
        };

        Product.prototype.onSkusChange = function() {
            var that = this;

            // DOM
            var $form = that.$form;

            var key = getKey(),
                sku = that.features[key];

            // PLUGIN https://www.webasyst.ru/store/plugin/shop/hideskus/
            if (window.waTheme.plugins.hideskus === "1" && typeof $.hideskusPlugin !== "undefined") {
                if (!$.hideskusPlugin.start(this, key)) {
                    return false;
                }
            }

            // set available skus
            let skus_state = window.waTheme.themesettings.settings["product__common_skus_available_type_buttons"]["value"];
            if (skus_state !== "none" && window.waTheme.license.is_premium === "1") {

                // fallback for removed setting
                skus_state = skus_state === "hide" ? "blocked" : skus_state;

                $form.find(".js-sku-feature").each( function () {
                    var $input = $(this);
                    var $select = $(this).parent(".inline-select");
                    var $items = $select.find("a");

                    $items.each(function () {
                        var _key = getKey($input.data("feature-id"), $(this).data("value")),
                            _sku = that.features[_key];

                        if (_sku) {
                            if (_sku.available) {
                                if (skus_state === "disabled" || skus_state === "blocked") { $(this).removeClass("btn-cross"); }
                                // if (skus_state === "disabled" || skus_state === "blocked") { $(this).removeClass("btn-gray-200").addClass("btn-outline-theme"); }
                                if (skus_state === "blocked") { $(this).removeClass("disabled").attr("aria-disabled", false); }
                            } else {
                                if (skus_state === "disabled" || skus_state === "blocked") { $(this).addClass("btn-cross"); }
                                // if (skus_state === "disabled" || skus_state === "blocked") { $(this).addClass("btn-gray-200").removeClass("btn-outline-theme"); }
                                if (skus_state === "blocked") { $(this).addClass("disabled").attr("aria-disabled", true); }
                            }
                        } else {
                            if (skus_state === "disabled" || skus_state === "blocked") { $(this).addClass("btn-cross"); }
                            // if (skus_state === "disabled" || skus_state === "blocked") { $(this).addClass("btn-gray-200").removeClass("btn-outline-theme"); }
                            if (skus_state === "blocked") { $(this).addClass("disabled").attr("aria-disabled", true); }
                        }
                    });
                });
            }

            var sku_id = null;

            if (sku) {
                var sku_name = false;
                try { sku_name = that.skus[sku.id].sku; } catch(e) {}

                that.sku_id = sku_id = sku.id;
                that.sku = that.skus[that.sku_id];

                if (that.add_by_quantity === "1") {
                    that.productInCart();
                } else {
                    that.quantity_controller.update({
                        step: that.sku.order_count_step,
                        min: that.sku.order_count_min,
                        max: (!that.ignore_stock_count && that.sku.count > 0 ? that.sku.count : 0),
                    });
                }

                // console.log(that.sku);

                renderSKU(sku_name);
                //
                that.updateSkuServices(sku.id);
                //
                that.changeImage(sku.image_id);
                //
                if (sku.available) {
                    that.toggleAvailable(true, that.sku, sku.id);
                } else {
                    that.toggleAvailable(false, that.sku, sku.id);
                }

                //
                sku["compare_price"] = ( sku["compare_price"] ) ? sku["compare_price"] : 0 ;
                //
                that.updatePrice();

            } else {
                //
                that.toggleAvailable(false, that.sku);
                //
                // that.$comparePrice.hide();
                //
                // that.$price.empty();
            }

            that.$form.trigger("product_sku_changed", [sku_id, sku]);

            function getKey(feature_id, data_value) {
                var result = "";

                $form.find(".js-sku-feature").each( function () {
                    var $input = $(this);

                    if (feature_id && feature_id === $input.data("feature-id")) {
                        result += $input.data("feature-id") + ':' + data_value + ';';
                    } else {
                        result += $input.data("feature-id") + ':' + $input.val() + ';';
                    }
                });

                return result;
            }
        };

        Product.prototype.onSkusClick = function( $link ) {
            var that = this,
                sku_id = $link.val(),
                price = $link.data("price"),
                compare_price = $link.data("compare-price"),
                image_id = $link.data('image-id'),
                name = $link.next("label").text();

            var sku = (that.skus[sku_id] ? that.skus[sku_id] : null);
            if (!sku) { alert("SKU ERROR"); return false; }

            that.sku_id = sku_id;
            that.sku = sku;

            // change name in dropdown
            $link.parents(".s-skus-wrapper").find(".s-skus-wrapper__dropdown-name").html(name);
            $link.parent(".dropdown-item").addClass("is-active");

            // Дает возможность добавлять товары при помощи переключателя кол-ва
            if (that.add_by_quantity === "1") {
                that.productInCart();
            } else {
                that.quantity_controller.update({
                    step: that.sku.order_count_step,
                    min: that.sku.order_count_min,
                    max: (!that.ignore_stock_count && that.sku.count > 0 ? that.sku.count : 0),
                });
            }

            renderSKU(sku.sku);

            that.changeImage(image_id);

            that.toggleAvailable(!$link.data('disabled'), sku, sku_id);

            //
            that.updateSkuServices(sku_id);
            //
            that.updatePrice();
            //
            that.$form.trigger("product_sku_changed", [sku_id, sku]);
        };

        Product.prototype.onSelectClick = function( $link ) {
            var $select = $link.closest('.inline-select'),
                $selected_value = $link.parents(".s-option").find(".js-skus-selected-value"),
                text = $link.data("sku-text"),
                data = $link.data("value"),
                active_class = "active";

            //
            $select.find("a." + active_class).removeClass(active_class);
            //
            $link.addClass(active_class);
            //
            $select.find(".js-sku-feature")
                .val(data)
                .change();
            //
            $selected_value.text(text);
        };

        Product.prototype.onServiceClick = function( $input ) {
            var that = this,
                $select = that.$form.find("select[name=\"service_variant[" + $input.val() + "]\"]");

            if ($select.length) {
                if ( $input.is(":checked") ) {
                    $select.removeAttr("disabled");

                } else {
                    $select.attr("disabled", "disabled");
                }
            }

            that.updatePrice();
        };

        Product.prototype.currencyFormat = function (number, no_html) {
            // Format a number with grouped thousands
            //
            // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
            // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // +	 bugfix by: Michael White (http://crestidg.com)

            var that = this;
            var i, j, kw, kd, km;
            var currency = that.currency_info;
            var decimals = currency.frac_digits;
            var dec_point = currency.decimal_point;
            var thousands_sep = currency.thousands_sep;

            // input sanitation & defaults
            if( isNaN(decimals = Math.abs(decimals)) ){
                decimals = 2;
            }
            if( dec_point === undefined ){
                dec_point = ",";
            }
            if( thousands_sep === undefined ){
                thousands_sep = ".";
            }

            i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

            if( (j = i.length) > 3 ){
                j = j % 3;
            } else{
                j = 0;
            }

            km = (j ? i.substr(0, j) + thousands_sep : "");
            kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
            //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
            kd = (decimals && (number - i) ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

            number = km + kw + kd;
            var s = no_html ? currency.sign : currency.sign_html;
            if (!currency.sign_position) {
                return s + currency.sign_delim + number;
            } else {
                return number + currency.sign_delim + s;
            }
        };

        Product.prototype.serviceVariantHtml= function (id, name, price) {
            var that = this,
                price_string = waTheme.formatPrice(price, { currency: that.currency, html: false });
            return $('<option data-price="' + price + '" value="' + id + '"></option>').text(name + ' (+' + price_string + ')');
        };

        Product.prototype.updateSkuServices = function(sku_id) {
            var that = this,
                $form = that.$form;

            for (var service_id in that.services[sku_id]) {

                var v = that.services[sku_id][service_id];

                if (v === false) {
                    $form.find(".service-" + service_id).hide().find('input,select').attr('disabled', 'disabled').removeAttr('checked');

                } else {
                    $form
                        .find(".service-" + service_id)
                            .show()
                            .find('input')
                                .removeAttr('disabled');

                    if (typeof (v) === 'string' || typeof (v) === 'number') {
                        var $service = $form.find(".service-" + service_id);

                        var price_string = waTheme.formatPrice(v, { currency: that.currency });

                        $service.find(".service-price").html(price_string);
                        $service.find("input").data("price", v);

                    } else {

                        var select = $form.find(".service-" + service_id + ' .service-variants');
                        var selected_variant_id = select.val();

                        for (var variant_id in v) {
                            var obj = select.find('option[value=' + variant_id + ']');

                            if (v[variant_id] === false) {
                                obj.hide();

                                if (obj.attr('value') == selected_variant_id) {
                                    selected_variant_id = false;
                                }

                            } else {

                                if (!selected_variant_id) {
                                    selected_variant_id = variant_id;
                                }

                                obj.replaceWith(that.serviceVariantHtml(variant_id, v[variant_id][0], v[variant_id][1]));
                            }
                        }

                        $form.find(".service-" + service_id + ' .service-variants').val(selected_variant_id);
                    }
                }
            }
        };

        Product.prototype.updatePrice = function() {
            var that = this;

            var hidden_class = "is-hidden";

            // DOM
            var $form = that.$form,
                $price = that.$price,
                $compare = that.$comparePrice;

            var price = that.sku["price"],
                compare_price = that.sku["compare_price"],
                stock_base_ratio = that.sku.stock_base_ratio,
                stock_unit_name,
                base_unit_name;

            price = (parseFloat(price) >= 0 ? parseFloat(price) : 0);
            compare_price = (parseFloat(compare_price) > 0 ? parseFloat(compare_price) : null);
            stock_base_ratio = (parseFloat(stock_base_ratio) > 0 ? parseFloat(stock_base_ratio) : null);

            if (that.fractional_config["stock_units_enabled"]) {
                if (that.product.stock_unit_id && that.units[that.product.stock_unit_id]) {
                    stock_unit_name = that.units[that.product.stock_unit_id].name_short;
                }
            }

            if (that.fractional_config["base_units_enabled"]) {
                if (that.product.base_unit_id && (that.product.stock_unit_id !== that.product.base_unit_id) && that.units[that.product.base_unit_id] && stock_base_ratio) {
                    base_unit_name = that.units[that.product.base_unit_id].name_short;
                }
            }

            //
            var services_price = getServicePrice(),
                price_sum = (price + services_price),
                compare_sum = (compare_price + services_price),
                price_total = (price + services_price) * that.quantity_controller.value;

            // Render Price
            var price_string = waTheme.formatPrice(price_sum, { currency: that.currency, unit: stock_unit_name });
            $price.html(price_string);

            // Render Compare
            if (compare_price) {
                var compare_price_string = waTheme.formatPrice(compare_sum, { currency: that.currency, unit: stock_unit_name });
                $compare
                    .html(compare_price_string)
                    .removeClass(hidden_class);

            } else {
                $compare.addClass(hidden_class);
            }

            // Base Price
            if (that.$base_price.length) {
                if (base_unit_name) {
                    var base_sub = (price_sum/stock_base_ratio),
                        base_price_string = waTheme.formatPrice(base_sub, { currency: that.currency, unit: base_unit_name });

                    if (compare_price) {
                        var base_compare_sub = (compare_price/stock_base_ratio),
                            base_compare_price_string = waTheme.formatPrice(base_compare_sub, { currency: that.currency, unit: base_unit_name });
                    }

                    that.$base_price
                        .html(base_price_string)
                        .show();
                } else {
                    that.$base_price.hide();
                }
            }

            // reverse base and stock price
            let reverse_price = window.waTheme.themesettings.settings["apps__shop_common_price_reverse"]["value"] === "1";
            if (reverse_price && base_price_string) {
                $price.html(base_price_string);
                that.$base_price.html(price_string);
                if (base_compare_price_string) {
                    $compare.html(base_compare_price_string);
                }
            }

            // Stock Base Ratio
            if (that.$stock_base_ratio.length) {
                if (stock_base_ratio) {
                    let stock_ratio = waTheme.localizeNumber(formatNumber(that.sku.stock_base_ratio), { currency: that.currency });

                    let reverse_stock = window.waTheme.themesettings.settings["apps__shop_common_stock_reverse"]["value"] === "1";
                    if (reverse_stock && that.sku.stock_base_ratio < 1) {
                        stock_ratio = waTheme.localizeNumber(formatNumber(that.sku.order_count_min), { currency: that.currency });
                    }

                    that.$stock_base_ratio
                        .html(stock_ratio)
                        .show();
                } else {
                    that.$stock_base_ratio
                        .hide()
                        .html("");
                }
            }

            //
            if (that.is_dialog) {
                // that.dialog.resize();
            }

            // Summary Price
            var price_summ_string = waTheme.formatPrice(price_total, { currency: that.currency });

            if (that.$total_price.length) {

                that.$total_price.html(price_summ_string);

                if (that.$stock_total_ratio.length) {
                    if (stock_base_ratio) {
                        that.$stock_total_quantity
                            .html(formatNumber(that.quantity_controller.value))
                            .show();
                        console.log(that.$stock_total_ratio.data("step"));
                        if (that.$stock_total_ratio.data("step")) {
                            that.$stock_total_ratio
                                .html(formatNumber((stock_base_ratio * (that.quantity_controller.value).toFixed(10) / parseInt(that.$stock_total_ratio.data("step")))))
                                .show();
                        } else {
                            that.$stock_total_ratio
                                .html(formatNumber((stock_base_ratio * that.quantity_controller.value).toFixed(10)))
                                .show();
                        }
                    } else {
                        that.$stock_total_quantity
                            .hide()
                            .html("");
                        that.$stock_total_ratio
                            .hide()
                            .html("");
                    }
                }
            }

            // Badges
            if (compare_price > 0) {
                that.$savings.removeClass("is-hidden");
                that.$savings.find(".b-product-savings__percent").removeClass("is-hidden");
                that.$savings.find(".b-product-savings__profit").removeClass("is-hidden");

                let savings_percent = Math.round((compare_price - price) / (compare_price / 100));
                that.$savings.find(".b-product-savings__percent").html(`- ${savings_percent} %`);

                let savings_price = waTheme.formatPrice(compare_price - price, { currency: that.currency, unit: stock_unit_name });
                that.$savings.find(".b-product-savings__profit").html(window.waTheme.locale.benefit + " " + savings_price);

            } else {
                that.$savings.addClass("is-hidden");
                that.$savings.find(".b-product-savings__percent").addClass("is-hidden");
                that.$savings.find(".b-product-savings__profit").addClass("is-hidden");
            }

            // Affiliate
            if (that.$affiliate_points.length && price !== 0) {
                let rate = that.$affiliate_points.data("rate");
                let points = Math.floor((price / rate));
                that.$affiliate_points.find(".js-product-affiliate__points").html(points);
            }

            // Zero Price
            if (price === 0) {
                that.$price.addClass(hidden_class);
                that.$comparePrice.addClass(hidden_class);
                // that.$total_price.parents(".s-summary-wrapper").addClass(hidden_class);
                that.$base_price.hide();
                that.$affiliate_points.addClass(hidden_class);
                that.$zero_price.removeClass(hidden_class);
            } else {
                that.$price.removeClass(hidden_class);
                // that.$total_price.parents(".s-summary-wrapper").removeClass(hidden_class);
                that.$affiliate_points.removeClass(hidden_class);
                that.$zero_price.addClass(hidden_class);
            }

            //
            function getServicePrice() {
                // DOM
                var $checkedServices = that.$services.find("input:checked");

                // DYNAMIC VARS
                var services_price = 0;

                $checkedServices.each( function () {
                    var $service = $(this),
                        service_value = $service.val(),
                        service_price = 0;

                    var $serviceVariants = $form.find(".service-" + service_value + " .service-variants");

                    if ($serviceVariants.length) {
                        service_price = parseFloat( $serviceVariants.find(":selected").data("price") );
                    } else {
                        service_price = parseFloat( $service.data("price") );
                    }

                    services_price += service_price;
                });

                return services_price;
            }

            function formatNumber(number) {
                var result = number;
                if (typeof number !== "string") { return result; }

                var float_num = parseFloat(number);
                if (float_num < 1) {
                    var split_num = number.split(".");
                    if (split_num.length === 2) {
                        var decimal_part = split_num[1].replace(/^0+/, '');
                        number = roundNumber(float_num, split_num[1].length - decimal_part.length + 3).toFixed(8);
                    }
                } else {
                    number = roundNumber(float_num, 3).toFixed(8);
                }

                var parts = number.split(".");
                if (parts.length === 2) {
                    var tail = parts[1],
                        result2 = [],
                        result3 = [parts[0]];

                    if (tail.length) {
                        for (var i = 0; i < tail.length; i++) {
                            var letter = tail[tail.length - (i+1)];
                            if (letter !== "0" || result2.length) {
                                result2.push(letter);
                            }
                        }
                        if (result2.length) {
                            result3.push(result2.reverse().join(""));
                        }
                    }

                    result = result3.join(".");
                }

                return result;
            }

            function roundNumber(num, scale) {
                if(!String(num).includes("e")) {
                    return +(Math.round(num + "e+" + scale)  + "e-" + scale);
                } else {
                    var parts = String(num).split("e"),
                        sig = "";

                    if(+parts[1] + scale > 0) {
                        sig = "+";
                    }
                    return +(Math.round(+parts[0] + "e" + sig + (+parts[1] + scale)) + "e-" + scale);
                }
            }
        };

        Product.prototype.changeImage = function(image_id) {
            var that = this;

            if (image_id) {
                var $link = $("#s-image-" + image_id);
                if ($link.length) {
                    window[that.thumbs].slideTo($link.index());
                    window[that.main].slideTo($link.index());
                }
            }
        };

        Product.prototype.toggleAvailable = function(available, sku, sku_id) {
            var that = this,
                cart_items = window.waTheme.cart_items,
                added_class = "is-added",
                is_added = false;

            if (sku_id) {
                for (const cartItemsKey in cart_items) {
                    if (cart_items[cartItemsKey]["sku_id"] === sku_id && is_added === false) {
                        is_added = true;
                        that.$button.addClass(added_class);
                        that.$button.removeClass("btn-theme").addClass("btn-outline-theme");
                        that.$button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);
                    }
                }
            }

            if (is_added === false) {
                that.$button.removeClass(added_class);
                that.$button.removeClass("btn-outline-theme").addClass("btn-theme");
                that.$button.find(".spinner-text").html(window.waTheme.locale["add_to_cart"]);
            }

            // toggle button
            that.$button.attr("disabled", !available);

            // добавление товара по фиксированной кнопке
            $(".js-product-submit").attr("disabled", !available);
            if (is_added === false) {
                $(".js-product-submit").removeClass("btn-outline-theme").addClass("btn-theme");
                $(".js-product-submit").html(window.waTheme.locale["add_to_cart"]);
            }

            // toggle stocks
            that.$form.find(".s-stocks-wrapper > div").each( function() {
                var $stock = $(this),
                    is_target = $stock.hasClass("sku-" + sku.id + "-stock");

                if (available && is_target) {
                    $stock.show();
                } else {
                    $stock.hide();
                }
            });

            that.$form.find(".s-stocks-wrapper > .sku-not-available").css("display", (available ? "none" : ""));

            // quantity
            if (that.add_by_quantity !== "1") {
                if (available) {
                    that.$quantity_section.removeClass("d-none");
                } else {
                    that.$quantity_section.addClass("d-none");
                }
            }
        };

        // Viewed products
        Product.prototype.productsViewed = function() {
            var that = this,
                $form = that.$form,
                $product_id = $form.find('input[name="product_id"]').val();

            var viewed = $.cookie('shop_viewed'); // Product Id's Array @string
            viewed = (viewed) ? viewed.split(',') : [];

            var index = $.inArray( $product_id + '', viewed);

            if (index == -1) {
                viewed.unshift($product_id);
                $.cookie('shop_viewed', viewed.join(','), { expires: 14, path: '/'});
            }
        };

        return Product;

        function renderSKU(sku) {
            var $sku = $(".js-product-sku"),
                $wrapper = $sku.closest(".s-sku-wrapper");

            if (sku) {
                $sku.text(sku);
                $wrapper.show();
            } else {
                $sku.text("");
                $wrapper.hide();
            }
        }

    })($);

    waTheme.init.shop.Product = Product;

    var $productQuantityWrapper = $("#js-quantity-section").removeAttr("id");
    if ($productQuantityWrapper.length) {
        let product_id = $productQuantityWrapper.parents(".s-product-page").data("product-id");
        new waTheme.init.shop.Quantity({
            $wrapper: $productQuantityWrapper,
            denominator: window.waTheme["products"][`${product_id}`].denominator,
            step: window.waTheme["products"][`${product_id}`].step,
            min: window.waTheme["products"][`${product_id}`].min,
            max: window.waTheme["products"][`${product_id}`].max,
            locales: window.waTheme["products"][`${product_id}`].locales,
            currency: window.waTheme["products"][`${product_id}`].currency,
        });
    }

    var $productCartWrapper = $("#js-product-cart").removeAttr("id");
    if ($productCartWrapper.length) {

        waTheme.addCurrency(window.waTheme.product.currency_data);

        new waTheme.init.shop.Product({
            $wrapper: $productCartWrapper,
            is_dialog: false,
            currency: window.waTheme.product.currency,
            currency_info: window.waTheme.product.currency_info,
            services: window.waTheme.product.services,
            features: window.waTheme.product.features,
            product: {
                sku_id: window.waTheme.product.product.sku_id,
                skus: window.waTheme.product.product.skus,
                stock_unit_id: window.waTheme.product.product.stock_unit_id,
                base_unit_id: window.waTheme.product.product.base_unit_id,
            },
            ignore_stock_count: window.waTheme.product.ignore_stock_count,
            fractional_config: window.waTheme.product.fractional_config,
            units: window.waTheme.product.units,
            locales: window.waTheme.product.locales,
        });
    }

})(jQuery, window.waTheme);